import {useEffect, useState} from 'react';

import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import './CurrencySelect.scss';
import useOnClickOutside from 'hooks/useOnClickOutside';

interface ICurrencySelectProps {
  id: number;
  currency: string;
  handleUpdatePrice: ({id, field, value}: {id: number; field: string; value: string}) => void;
}

const CurrencySelect = ({currency, handleUpdatePrice, id}: ICurrencySelectProps) => {
  const valuesMap: {[key: string]: string} = {
    0: 'RSD',
    1: 'EUR',
    2: 'USD',
  };

  const [showList, setShowList] = useState(false);
  const [toggleList, setToggleList] = useState(false);

  const handleChange = ({id, field, value}: {id: number; field: string; value: string}) => {
    handleUpdatePrice({id, field, value});
    setShowList(false);
  };

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setShowList(false);
  });

  useEffect(() => {
    setShowList(toggleList);
  }, [toggleList]);

  return (
    <div className="currency-select">
      <Button
        variant="empty"
        onClick={() => setToggleList((currState) => !currState)}
        className={`currency-select__value ${showList ? 'currency-select__value--expanded' : ''}`}
      >
        {valuesMap[currency]}
        <Icon icon="chevron-down" />
      </Button>
      {showList && (
        <div className="currency-select__list" ref={containerRef}>
          <ul>
            <li>
              <Button variant="empty" onClick={() => handleChange({id, field: 'currency', value: '0'})}>
                RSD
              </Button>
            </li>
            <li>
              <Button variant="empty" onClick={() => handleChange({id, field: 'currency', value: '1'})}>
                EUR
              </Button>
            </li>
            <li>
              <Button variant="empty" onClick={() => handleChange({id, field: 'currency', value: '2'})}>
                USD
              </Button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default CurrencySelect;
